export default function Loader () {

    return(
        <div className={`loader-main-container`}>
            <div className="loader"></div>
        </div>
    )
}